import React from 'react';

const Tensors = () => {
    return (
        <div>Tensors Component</div>
    );
}

export default Tensors;
